const autoNgTemplateLoaderTemplate1 = require('./views/repositories/edit/template.html');

angular.module('portainer.registrymanagement', []).config([
  '$stateRegistryProvider',
  function ($stateRegistryProvider) {
    'use strict';

    var registryConfiguration = {
      name: 'portainer.registries.registry.configure',
      url: '/configure',
      views: {
        'content@': {
          component: 'configureRegistryView',
        },
      },
    };

    var registryRepositories = {
      name: 'portainer.registries.registry.repositories',
      url: '/repositories?endpointId',
      views: {
        'content@': {
          component: 'registryRepositoriesView',
        },
      },
      data: {
        docs: '/admin/registries/browse',
      },
    };

    var registryRepositoryTags = {
      name: 'portainer.registries.registry.repository',
      url: '/:repository?endpointId',
      views: {
        'content@': {
          templateUrl: autoNgTemplateLoaderTemplate1,
          controller: 'RegistryRepositoryController',
        },
      },
    };
    var registryRepositoryTag = {
      name: 'portainer.registries.registry.repository.tag',
      url: '/:tag',
      views: {
        'content@': {
          component: 'registryRepositoryTagView',
        },
      },
    };

    $stateRegistryProvider.register(registryConfiguration);
    $stateRegistryProvider.register(registryRepositories);
    $stateRegistryProvider.register(registryRepositoryTags);
    $stateRegistryProvider.register(registryRepositoryTag);
  },
]);
